export const AccommodationsActionTypes = {
  API_RESPONSE_SUCCESS: '@@accommodations/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@accommodations/API_RESPONSE_ERROR',

  GET_ACCOMMODATION: '@@accommodations/GET_ACCOMMODATION',
  LIST_ACCOMMODATIONS: '@@accommodations/LIST_ACCOMMODATIONS',
  ADD_ACCOMMODATION: '@@accommodations/ADD_ACCOMMODATION',
  UPDATE_ACCOMMODATION: '@@accommodations/UPDATE_ACCOMMODATION',
  DELETE_ACCOMMODATION: '@@accommodations/DELETE_ACCOMMODATION',

  GET_ACCOMMODATION_CHARTS: '@@accommodations/GET_ACCOMMODATION_CHARTS',
  GET_ACCOMMODATIONS_FOR_EXCEL: '@@accommodations/GET_ACCOMMODATIONS_FOR_EXCEL',

  RESET: '@@accommodations/RESET'
}
